import React from "react";
import { redirectToPss } from "helpers/user-session";
import NoAssessments from "../emptystate/noassessments";
import AssessmentsUnavailable from "../emptystate/assessments-unavailable";
import AssessmentList from "./assessment-list";
import { useAssessments } from "../context/assessment-provider";
import { LicensedEnum } from "../types";
import BackButton from "../components/backbutton";
import AssessmentLoading from "../components/assessment-loading";

function AssessmentScreen() {
  const { assessments, grade, licensed, loading } = useAssessments();

  const viewType = (grade ?? 0) < 3 ? "gradekto2" : "grade3plus";

  // Check if School/District has access
  if (licensed === LicensedEnum.UNLICENSED) {
    return <AssessmentsUnavailable />;
  }

  if (loading) {
    return <AssessmentLoading />;
  }

  return (
    <div className={`assessment-screen ${viewType}`}>
      <BackButton
        onClick={() => {
          redirectToPss();
        }}
      />
      {assessments && assessments.length > 0 ? (
        <AssessmentList assessmentData={assessments} viewType={viewType} />
      ) : (
        <NoAssessments />
      )}
    </div>
  );
}

export default AssessmentScreen;
